import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";

import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import moment from "moment";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import XCloseIcon from "../../../../component/icons/x-close";
import Chip from "../../../../component/ui/chip";
import Tooltip from "../../../../component/ui/tooltip";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFooter,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import { PlusIcon } from "lucide-react";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import RefundForm from "../../refundForm";

const OrgRefundsBySource = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [changeModal, setChangeModal] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [currentStatus, setCurrentStatus] = useState("");
  const [brands, setBrands] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);


  const [tableFooter, setTableFooter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [showRefund, setShowRefund] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    // getHolidays()
    getData({});
  }, []);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 10 };
    let extraUrl = `&page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    // let extraUrl = "";
    // for (let i = 0; i < filter?.length; i++) {
    //   let objKey = (filter[0]?.selectedOpt == "between") ? "date_range" : filter[i]?.name
    //   apiData = {
    //     ...apiData,
    //     [objKey]: (filter[0]?.selectedOpt == "between") ? `${filter[i]?.value[0]}_${filter[i]?.value[1]}` : filter[i]?.value
    //   }
    //   // extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`
    // }
    try {
      const res = await apiCall({
        method: "get",
        url: `reports/source-refund`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTableFooter(res?.footer);

      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };



  const handleToggleAll = () => {
    const allIds = apiData.map(
      (ele) => `${ele.employee_id}---${ele.holiday_id}`
    );
    const isAllChecked = selectedIds?.length === allIds?.length;
    setSelectedIds(isAllChecked ? [] : allIds);
  };

  const handleToggleOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setSelectedIds([]);
    getData({});
    setChangeModal(false);
    setShowRefund(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const onStatusChange = (value) => {
    setCurrentStatus(value);
    setChangeModal(true);
  };

  const removeFilter = (fIndex) => {
    let allFilter = [...filterReturn];
    allFilter.splice(fIndex, 1);
    setFilterReturn(allFilter);
    getData({ filter: allFilter });
  };

  const filterModalData = [
    {
      name: "date_filter",
      label: "By Date",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "This Week", value: "this_week" },
        { label: "This Month", value: "this_month" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },
  ];

  const editRefund = (ele) => {
    setCurrentData(ele);
    setShowRefund(true);
  };

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody}`}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {filterReturn?.length ? (
                <div className={Style.filterContainer}>
                  <p className={Style.searchText}>Search By</p>

                  {filterReturn?.map((eachFilter, i) => {
                    return (
                      <div className={Style.eachFilter} key={i}>
                        <p
                          onClick={() => {
                            setShowModalFilterTable(true);
                          }}
                        >
                          <span>
                            {eachFilter?.name
                              ?.replace("search_by_", "")
                              .replaceAll("_", " ")}{" "}
                            :{" "}
                          </span>
                          <b>{eachFilter?.selectedOperator}</b>
                          <em>
                            {typeof eachFilter?.value == "string"
                              ? eachFilter?.value
                              : eachFilter?.value?.map((eachVal, index) => {
                                return `${eachVal} ${eachFilter?.value?.length - 1 != index
                                  ? "& "
                                  : ""
                                  }`;
                              })}
                          </em>
                        </p>

                        <span
                          className={Style.searchClosedBtn}
                          onClick={() => {
                            removeFilter(i);
                          }}
                        >
                          <div className={Style.icon}>
                            <XCloseIcon />
                          </div>
                        </span>
                      </div>
                    );
                  })}
                </div>
              ) : null}

              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  {/* <div className={Style.bpfl_select}>
                    <select
                      onChange={(e) => {
                        getData({ page_quantity: e?.target.value });
                        setPageCount(1);
                        setPageItemsCount(e?.target.value);
                      }}
                    >
                      <option value="10">View 10</option>
                      <option value="25">View 25</option>
                      <option value="50">View 50</option>
                      <option value="100">View 100</option>
                      <option value="all">View all</option>
                    </select>
                  </div> */}

                  <div>
                    <h1 className="text-xl font-bold pl-3 flex items-center gap-1">Refund By Source</h1>
                  </div>
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <div
                      className={Style.bpfl_action}
                      onClick={() => {
                        setShowRefund(true);
                      }}
                    >
                      <Tooltip
                        content={"Add Refund"}
                        position={"left center"}
                        className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                      >
                        <div className={Style.icon}>
                          <PlusIcon size="1em" />
                        </div>
                      </Tooltip>
                    </div>

                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                          }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <DataNotFound title={"Refund"} />
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              {/* <div className="flex gap-4 items-center">
                                <span>User Details</span>
                              </div> */}
                              <TableHeaderWrap>
                                <span>Source</span>
                              </TableHeaderWrap>
                            </TableCell>

                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                                eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  {/* {eachList?.client_name ?? "-"} */}

                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    <div className="flex items-center gap-3">
                                      <div className="font-medium leading-5">
                                        {eachList?.source ?? "-"}
                                      </div>
                                    </div>

                                    {/* <div
                                      className={Style.tableActionAreaBtnGrpup}
                                    >
                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                        onClick={() => {
                                          editRefund(eachList);
                                        }}
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#FF9500" }}
                                        >
                                          <NewEditIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                      // onClick={() => {
                                      //   setEmpPopup(true);
                                      //   setEmpData(eachList);
                                      // }}
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#007AFF" }}
                                        >
                                          <NewEyeIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>
                                    </div> */}
                                  </div>
                                </TableCell>

                                {tableHeader?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 &&
                                    eachHead?.show == 1 ? (
                                    <TableCell key={`${i}-${index}`}>
                                      {eachList?.[eachHead?.key] ?? "-"}
                                    </TableCell>
                                  ) : null
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>

                        <TableFooter>
                          <TableRow>
                            <TableCell
                              sticky
                              header
                              className="text-gray-800 font-bold tracking-wide uppercase"
                            >
                              Summary
                            </TableCell>

                            {tableHeader.map((h_ele, h_idx) => (
                              <TableCell
                                header
                                key={`tf-${h_idx}`}
                                className={`${h_ele?.type === "number" ? "!text-end font-number" : ""
                                  } ${h_ele?.key === "credit"
                                    ? "!text-green-600 font-semibold"
                                    : h_ele?.key === "debit"
                                      ? "!text-red-600 font-semibold"
                                      : ""
                                  }`}
                              >
                                {tableFooter[h_ele?.key] ?? "--"}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>

              {!isLoading ? (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  {/* <div className={Style.table_footer_left}>
                    {`showing 1 to ${apiData?.length} of ${tablePagination?.total || apiData?.length
                      }`}
                  </div> */}

                  {tablePagination ? (
                    <div className={Style.empDirectory_footer}>
                      {tablePagination?.next_page_url ? (
                        <button
                          className={Style.loadMoreBtn}
                          onClick={() => {
                            if (btnLoader) return;
                            // setPageCount(pageCount + 1);
                            setBtnLoader(true);
                            // filterData({ page: pageCount + 1, btnCall: true });
                            getData({
                              page: tablePagination?.next_page_url,
                            });
                          }}
                        >
                          {btnLoader ? (
                            <InnerLoader
                              className={Style.loader}
                              textStatus={false}
                            />
                          ) : (
                            "Load More"
                          )}
                        </button>
                      ) : null}
                    </div>
                  ) : null}

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="source-refund"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="source-refund"
        />
      )}

      {showRefund && (
        <RefundForm
          onError={onError}
          onSubmit={onSuccess}
          onClose={() => {
            setShowRefund(false);
            setCurrentData({})
          }}
          refundDataId={currentData}
        />
      )}

      {/* {changeModal &&
        <ChangeHolidayStatus onClose={() => {setChangeModal(false); setCurrentStatus("")}} onSubmit={onSuccess} onError={onError} selectedList={selectedIds} selectedStatus={currentStatus} />
      } */}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default OrgRefundsBySource;
